import React from "react";
import Logo from "../assets/images/teckpik-original-logo.png";
import { Button, Offcanvas } from "react-bootstrap";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [show, setShow] = useState(false);

  // New function to handle the contact button click
  const handleContactClick = () => {
    // Navigate to the contact page
    window.location.href = "/contact";
    // Close the mobile menu if it's open
    setShow(false);
  };

  return (
    <header className="navbar-container sticky-top bg-white shadow-sm">
      <div className="container-fluid d-flex justify-content-between align-items-center py-2">
        {/* Logo */}
        <div className="logo">
          <Link to={"/"}>
            <img src={Logo} alt="TECKPIK" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <nav className="d-none d-md-flex gap-5 fw-semibold">
          <a href="/">HOME</a>
          <a href="/services">SERVICES</a>
          <a href="/projects">PROJECTS</a>
          <a href="/about">ABOUT</a>
        </nav>

        {/* Desktop Contact Button */}
        <div className="d-none d-md-block">
          {/* 1. Add onClick handler here */}
          <Button className="btn contact-btn" onClick={handleContactClick}>
            Contact
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <div className="d-md-none">
          <button className="mobile-menu-btn" onClick={() => setShow(true)}>
            ☰
          </button>
        </div>
      </div>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas show={show} onHide={() => setShow(false)} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <nav className="mobile-nav">
            <a href="/">HOME</a>
            <a href="/services">SERVICES</a>
            <a href="/projects">PROJECTS</a>
            <a href="/about">ABOUT</a>

            {/* 2. Add onClick handler here */}
            <Button
              className="btn w-100 mt-3 contact-btn"
              onClick={handleContactClick}
            >
              Contact
            </Button>
          </nav>
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
};

export default Navbar;
